import { RESERVED_SLUGS, SLUG_FORMAT_REGEX, SLUG_MAX_LENGTH, SLUG_MIN_LENGTH, } from '../constants/index.js';
/**
 * Convert a free-form display name into a candidate slug. Lowercases, replaces
 * whitespace runs with `-`, strips characters outside `[a-z0-9-]`, collapses
 * consecutive hyphens, trims leading/trailing hyphens. Returns the result as-is
 * — the caller is responsible for fallback handling if the output is empty or
 * fails {@link validateSlugFormat}.
 */
export function slugify(name) {
    return name
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
}
export function isReservedSlug(slug) {
    return RESERVED_SLUGS.includes(slug);
}
/**
 * Returns true iff `slug` matches the canonical format: lowercase letter start,
 * 3-30 chars total, lowercase alphanumeric + hyphens, no consecutive hyphens.
 * The regex alone allows consecutive hyphens, so we double-check here.
 */
export function validateSlugFormat(slug) {
    if (slug.length < SLUG_MIN_LENGTH || slug.length > SLUG_MAX_LENGTH)
        return false;
    if (!SLUG_FORMAT_REGEX.test(slug))
        return false;
    if (slug.includes('--'))
        return false;
    if (slug.endsWith('-'))
        return false;
    return true;
}
//# sourceMappingURL=slug.js.map